export function fetch(id) { return { type: 'STAFFS/FETCH', id } }
export function fetch_one(id) { return { type: 'GUEST/FETCH', id } }
export function fetch_bookings(id) { return { type: 'GUEST/BOOKINGS/FETCH', id } }
export function archive(id, IdProperty) { return { type: 'STAFF/ARCHIVE', id, IdProperty } }
export function toggle(id, IsActive) { return { type: 'STAFF/TOGGLE', id, IsActive } }
export function clear() { return { type: 'GUEST/CLEAR' } }